module.exports = __webpack_public_path__ + "static/media/fav_no_episodes.d94d36c5.png";